import React, { FC, memo, useCallback, useRef, useState } from 'react'
import cn from 'classnames'
import { useStore } from 'store'
import { observer } from 'mobx-react'
import { NavLink } from 'react-router-dom'
import ReactPlayer from 'react-player'

import { SectionContainer } from 'containers/SectionContainer'
import { InnerContainer } from 'containers/InnerContainer'
import { TitleSection } from 'components/TitleSection'
import { ButtonMUI } from 'components/ButtonMUI'
import { TitleBottomSection } from 'components/TitleBottomSection'
import { VideoCarousel } from 'components/VideosCarousel'

import { cloudinary, staticMultimedia } from 'utils'

import styles from './styles.module.scss'
import { quality } from '@cloudinary/url-gen/actions/delivery'
import { auto } from '@cloudinary/url-gen/qualifiers/quality'

interface IProps {
}

const DiscoverSection: FC<IProps> = props => {
  const [isClickPlay, setIsClickPlay] = useState(false)
  const [isPlaying, setIsPlaying] = useState(false)
  const [playingVideo, setPlayingVideo] = useState('https://youtu.be/gBuM3n0jDNM')

  const handleClickPlay = () => {
    setIsClickPlay(true)
    setIsPlaying(true)
  }

  const handleClickPause = () => {
    setIsPlaying(false)
  }

  const onClickVideo = useCallback((value: string) => {
    setPlayingVideo(value)
  }, [])


  return (
    <SectionContainer>
      <InnerContainer style={{ height: '100%', alignItems: 'stretch', borderBottom: '1px solid white' }}>
        <div className={styles.discoverContainer}>
          <TitleSection title={<>Discover Somnium&nbsp;3.0: A&nbsp;Glimpse of What's New</>}
                        subTitle={'Embrace Decentralized Ownership'}/>
          <div className={styles.videoBlock}>
            <div className={styles.videoDescription}>
              Experience the evolution of the Somnium Space platform with our showcase of the most thrilling features
              and enhancements introduced in Somnium 3.0. Immerse yourself in a visual journey through our gallery of
              videos, each highlighting key updates that shape the future of the metaverse.
              <br/><br/>
              From upgraded environments to decentralized marketplaces, enhanced avatars to immersive weather systems,
              witness the transformation firsthand. These videos offer a snapshot of the innovations that await you in
              Somnium 3.0.
            </div>
            <div className={cn({
              [styles.videoPlayerWrapper]: true
            })}>
              <ReactPlayer
                url={playingVideo}
                className={styles.reactPlayer}
                volume={0}
                playing={isPlaying}
                loop
                muted
                playsinline
                width="100%"
                height="100%"
                onPlay={handleClickPlay}
                onPause={handleClickPause}
                onEnded={handleClickPause}
                config={{
                  file: {
                    attributes: {
                      preload: 'metadata'
                    }
                  },
                  youtube: {
                    playerVars: {
                      controls: 1
                      // origin: process.env.REACT_APP_YOUTUBE_ORIGIN_URL
                    }
                  }
                }}
              />
              {!isClickPlay
                ? <div className={styles.videoTitleBox}>
                  <div className={styles.videoTitle}>
                    Improved Base Reality World & Weather System
                  </div>
                </div>
                : null}
            </div>
          </div>
          <VideoCarousel playingVideo={playingVideo} onClick={onClickVideo}/>
          <div className={styles.bottomBlock}>
            <TitleBottomSection title={'Embrace the Evolution: Explore Somnium V3.0 Update'}
                                subTitle={'Immerse yourself in the possibilities of Somnium V3.0. Dive into the details, explore the documentation, and be among the first to experience the alpha version. Join the journey of shaping the metaverse.'}/>
            <div className={styles.rightBox}>
              <div className={styles.btnBoxFirst}>
                <NavLink to="/documentation">
                  <ButtonMUI styleType={'white'}
                    // onClick={}
                             type="button"
                             sx={{
                               '&&': {
                                 height: '60px',
                                 borderRadius: '30px'
                               }
                             }}>Documentation</ButtonMUI>
                </NavLink>
              </div>
              <div className={styles.btnBoxSecond}>
                <ButtonMUI styleType={'green_2'}
                           onClick={() => window.open('https://discord.com/invite/somniumspace', '_blank', 'noopener,noreferrer')}
                           startIcon={<img style={{ width: '20px', height: '15px' }}
                                           src={staticMultimedia.discord}
                                           alt="discord"/>}
                           type="button"
                           sx={{
                             '&&': {
                               height: '60px',
                               borderRadius: '30px'
                             },
                             'span': {
                               marginLeft: 0
                             }
                           }}>Discuss the Update</ButtonMUI>
              </div>
            </div>
          </div>

        </div>
      </InnerContainer>
    </SectionContainer>
  )
}

export default memo(DiscoverSection)
